import { esc } from '../ui/icons.js';
import { dados, recarregarFechamento } from '../state.js';
import * as Empresas from '../data/empresas.js';
import * as Fechamento from '../data/fechamento.js';
import { usuario, ehGestao } from '../auth.js';

/**
 * Configurações — o que a gestão precisa administrar.
 *
 * A tela era um texto de "reservado para o protótipo final". Agora resolve
 * dois problemas reais: distribuir a carteira (férias, saída, redistribuição)
 * e abrir competências de todas as empresas de uma vez.
 */

let aoMudarDados = () => {};

export function configurar({ onChange }) {
  aoMudarDados = onChange || (() => {});
}

export function render() {
  const wrap = document.getElementById('configWrap');

  if (!ehGestao()) {
    wrap.innerHTML = `
      <p style="font-size:13px;color:var(--text-secondary);line-height:1.6;margin:0;">
        Esta tela é da gestão. Aqui se distribui a carteira de empresas entre a
        equipe e se abrem as competências do mês. Se precisar assumir uma empresa
        que não é sua, fale com a Beatriz.
      </p>`;
    return;
  }

  const ano = new Date().getFullYear();
  const mesAtual = String(new Date().getMonth() + 1).padStart(2, '0');

  wrap.innerHTML = `
    <div class="config-bloco">
      <h3>Competências</h3>
      <p class="config-ajuda">
        O mês novo abre sozinho todo dia 1º. Use isto para regularizar atraso —
        abrir de uma vez os meses de trás de <b>todas</b> as empresas vigentes.
        Todo cliente recebe os 12 meses; a equipe marca o que realizou.
        Rodar de novo não duplica nada: só cria o que falta.
      </p>
      <div class="config-linha">
        <div><label>De</label><input type="month" class="cad-input" id="cfgDe" value="${ano}-01"></div>
        <div><label>Até</label><input type="month" class="cad-input" id="cfgAte" value="${ano}-${mesAtual}"></div>
        <button class="btn primary" id="cfgAbrir" type="button">Abrir para todas</button>
      </div>
      <p class="config-resultado" id="cfgResultado" hidden></p>
    </div>

    <div class="config-bloco">
      <h3>Carteira por colaborador</h3>
      <p class="config-ajuda">
        Marque quem responde por cada empresa. Mais de um pode dividir a mesma —
        é o caso das empresas maiores. Quem não está marcado vê os dados, mas
        não edita.
      </p>
      <div class="table-wrap">
        <table class="config-tabela">
          <thead>
            <tr>
              <th>Empresa</th>
              ${dados.colaboradores.map((c) => `<th style="text-align:center;">${esc(c.nome)}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${dados.empresas.map((e) => `
              <tr>
                <td><b>${esc(e.nome)}</b><div style="font-size:11px;color:var(--text-muted);">${esc(e.regime || '—')} · ${esc(e.periodicidade)}</div></td>
                ${dados.colaboradores.map((c) => {
                  const marcado = (e.responsaveis || []).some((r) => r.id === c.id);
                  return `<td style="text-align:center;">
                    <input type="checkbox" data-empresa="${e.id}" data-colab="${c.id}" ${marcado ? 'checked' : ''}>
                  </td>`;
                }).join('')}
              </tr>`).join('')}
          </tbody>
        </table>
      </div>
      <p class="config-resultado" id="cfgSalvo" hidden>Carteira atualizada.</p>
    </div>

    <div class="config-bloco">
      <h3>Equipe</h3>
      <p class="config-ajuda">
        Contas novas e senhas são criadas no painel do Supabase, em
        <i>Authentication → Users</i> — não por aqui.
      </p>
      <div class="table-wrap">
        <table class="config-tabela">
          <thead><tr><th>Nome</th><th>E-mail</th><th>Papel</th><th>Empresas</th></tr></thead>
          <tbody>
            ${dados.colaboradores.map((c) => {
              const n = dados.empresas.filter((e) => (e.responsaveis || []).some((r) => r.id === c.id)).length;
              return `<tr>
                <td><b>${esc(c.nome)}</b></td>
                <td>${esc(c.email)}</td>
                <td><span class="tag ${c.papel === 'gestao' ? 'purple' : 'green'}">${c.papel === 'gestao' ? 'Gestão' : 'Colaborador'}</span></td>
                <td>${n}</td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>
    </div>`;

  ligar();
}

function ligar() {
  const wrap = document.getElementById('configWrap');

  wrap.querySelector('#cfgAbrir')?.addEventListener('click', async (ev) => {
    const botao = ev.currentTarget;
    const de = wrap.querySelector('#cfgDe').value;
    const ate = wrap.querySelector('#cfgAte').value;
    const saida = wrap.querySelector('#cfgResultado');
    if (!de || !ate) return;

    botao.disabled = true;
    botao.textContent = 'Abrindo…';
    saida.hidden = true;

    try {
      const criadas = await Fechamento.abrirCompetenciasTodas(`${de}-01`, `${ate}-01`);
      await recarregarFechamento();
      await aoMudarDados();
      render();
      const nova = document.getElementById('cfgResultado');
      nova.textContent = criadas
        ? `${criadas} competência(s) criada(s).`
        : 'Nenhuma competência nova — todas já existiam nesse intervalo.';
      nova.hidden = false;
    } catch (err) {
      saida.textContent = 'Não foi possível abrir: ' + err.message;
      saida.hidden = false;
      botao.disabled = false;
      botao.textContent = 'Abrir para todas';
    }
  });

  wrap.querySelectorAll('[data-empresa][data-colab]').forEach((chk) =>
    chk.addEventListener('change', async () => {
      const empresaId = chk.dataset.empresa;
      const empresa = dados.empresas.find((e) => e.id === empresaId);
      const atuais = new Set((empresa?.responsaveis || []).map((r) => r.id));

      if (chk.checked) atuais.add(chk.dataset.colab);
      else atuais.delete(chk.dataset.colab);

      try {
        await Empresas.definirResponsaveis(empresaId, [...atuais]);
        await recarregarFechamento();
        await aoMudarDados();
        const aviso = document.getElementById('cfgSalvo');
        if (aviso) { aviso.hidden = false; setTimeout(() => { aviso.hidden = true; }, 2000); }
      } catch (err) {
        chk.checked = !chk.checked;
        alert('Não foi possível alterar a carteira: ' + err.message);
      }
    })
  );
}
